import { methodologyHero } from '../../content/methodology';

export function MethodologyHero() {
  return (
    <section className="methodology-hero">
      <p className="methodology-hero__eyebrow">{methodologyHero.eyebrow}</p>
      <h2>{methodologyHero.title}</h2>
      <p className="methodology-hero__lead">{methodologyHero.lead}</p>
      <p className="methodology-hero__note">{methodologyHero.honestNote}</p>
    </section>
  );
}
